const scrollToHash = () => {
  if (!window.location.hash) {
    return;
  }

  const id = decodeURIComponent(window.location.hash.slice(1));
  const target = document.getElementById(id);

  if (!target) {
    return;
  }

  target.scrollIntoView({ block: "start" });
};

const scrollToHashAfterLayoutSettles = () => {
  if (!window.location.hash) {
    return;
  }

  requestAnimationFrame(() => {
    scrollToHash();
    window.setTimeout(scrollToHash, 350);
  });
};

const scrollToTopAfterRouteChange = () => {
  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0 });
  });
};

export const onInitialClientRender = scrollToHashAfterLayoutSettles;

export const onRouteUpdate = () => {
  if (window.location.hash) {
    scrollToHashAfterLayoutSettles();
    return;
  }

  scrollToTopAfterRouteChange();
};
